import React from "react"; 
import { Link } from "react-router-dom";    
import EditDeliveryTermForm from "../../../components/Dashboard/DeliveryTermsListContent/Edit";

const EditDeliveryTerm = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit delivery Term</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Delivery Terms</li>
          <li>Edit delivery Term</li>
        </ul>
      </div> */}

      <EditDeliveryTermForm />
    </>
  );
};

export default EditDeliveryTerm;
